import { useTranslation } from "react-i18next";
import { Eye, EyeOff } from "lucide-react";
import { cn } from "@/shared/lib/utils";

interface FeatureFlagVisibilityBadgeProps {
  readonly isPublic: boolean;
}

export function FeatureFlagVisibilityBadge({ isPublic }: FeatureFlagVisibilityBadgeProps) {
  const { t } = useTranslation();
  const Icon = isPublic ? Eye : EyeOff;
  return (
    <span
      data-testid={`feature-flag-visibility-${isPublic ? "public" : "internal"}`}
      className={cn(
        "inline-flex items-center gap-1 rounded-full border px-2 py-0.5 font-sans text-[10px] font-semibold uppercase tracking-wide",
        isPublic
          ? "border-wander-orange/30 bg-wander-orange/10 text-wander-orange"
          : "border-border bg-muted text-muted-foreground",
      )}
    >
      <Icon className="h-3 w-3" aria-hidden="true" />
      {t(isPublic ? "featureFlags.visibility.public" : "featureFlags.visibility.internal")}
    </span>
  );
}
